import type { IH2OTheme } from '../../../../models/components.models';
import type { NavigationSectionStyles } from './types';

export const navigationSectionStyles = (theme: IH2OTheme): NavigationSectionStyles => ({
  root: {
    overflow: 'visible',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: '100%',
      zIndex: -1,
      background: theme.palette?.white,
    },
  },
  rootWrapper: {
    overflowY: 'auto',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  top: {},
  bottom: {
    marginTop: 'auto',
    color: theme.palette?.gray400,
  },
});
